/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react';

import { getIsMobileDevice, openInDefaultBrowser } from '@tiendanube/nexo';

import { download } from 'commons/utils';

import nexo from 'nexoClient';

import { Define } from '../nexo/define';
import { post } from '../query/documents';

type ReportsType = {
  handleDownload: (file: string) => void;
};

const usePrintReports = (): ReportsType => {
  const handleDownload = async (file: string): Promise<void> => {
    const usingNexo = new Define();

    const isMobileDevice = usingNexo.nexo
      ? await getIsMobileDevice(nexo)
      : false;

    if (isMobileDevice) {
      openInDefaultBrowser(nexo, file);
    } else {
      download.handleForceDownload(file);
    }
  };

  return {
    handleDownload
  };
};

export default usePrintReports;
